import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "watchlist_container watchlist_post_container bg-dark-container",
  ref: "col_watchlist"
}
const _hoisted_2 = {
  key: 0,
  class: "watchlist_table_head"
}
const _hoisted_3 = { class: "wathlistScrollContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddAndEditWatchlistCard = _resolveComponent("AddAndEditWatchlistCard")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_ctx.postModel)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.postModel.watchlistCategory)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.postModel.watchlistCategory), 1))
          : _createCommentVNode("", true),
        (
        _ctx.postModel.watchList.stocks &&
        _ctx.postModel.watchList.stocks.length &&
        _ctx.postModel.postSubType == 'watchlist'
      )
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["watchlist_table_body", {
        smallColSize: _ctx.sizeClass,
      }])
            }, [
              _createVNode(_component_el_scrollbar, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.postModel.watchList.stocks, (watchlist, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: watchlist.id,
                        class: "CardInnerDvWatchlistInfo"
                      }, [
                        _createVNode(_component_AddAndEditWatchlistCard, {
                          trade: watchlist,
                          showRemove: _ctx.isCreateView,
                          onOnRemove: () => _ctx.removeItem(index),
                          staticRemove: true,
                          isFluid: true,
                          showChart: false,
                          market: watchlist.type
                        }, null, 8, ["trade", "showRemove", "onOnRemove", "market"])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              })
            ], 2))
          : _createCommentVNode("", true)
      ], 512))
    : _createCommentVNode("", true)
}